import BulletIcon from "../../assets/product-list-assets/bullet.svg";
import type { ProductListGroup } from "../../types";

export const physicalSecurityBullet: ProductListGroup = {
  id: "physicalSecurityBullet",
  title: "bullet.title",
  seriesLabel: "modelCompare.seriesLabel.physicalSecurityBullet",
  icon: {
    src: BulletIcon,
    width: 24,
    height: 21,
  },
};
